import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE } from "@/lib/api";
import axios from "axios";
import { toast } from "sonner";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Award, Copy } from "lucide-react";

const CERT_VERIFY_BASE_URL = process.env.REACT_APP_CERT_VERIFY_BASE_URL || "http://localhost:3000/verify";

export default function Verify() {
    const { certNumber } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        axios.get(`${API_BASE}/verify/${certNumber}`).then(r => setData(r.data)).finally(() => setLoading(false));
    }, [certNumber]);

    return (
        <div className="min-h-screen bg-background flex items-center justify-center p-6">
            <Card className="mx-card max-w-lg w-full">
                <CardContent className="p-10 text-center">
                    <div className="h-16 w-16 mx-auto rounded-2xl bg-amber-gradient flex items-center justify-center text-white shadow-mx-md">
                        <Award className="h-8 w-8" />
                    </div>
                    <div className="font-display text-xl mt-4">MX Academy</div>
                    <div className="text-xs uppercase tracking-widest font-bold text-muted-foreground mt-1">Certificate verification</div>
                    {loading ? <div className="mt-8 text-muted-foreground">Verifying…</div> :
                        data?.valid ? (
                            <div className="mt-8">
                                <CheckCircle2 className="h-12 w-12 text-[#16A34A] mx-auto" />
                                <div className="font-display text-2xl mt-3 text-[#16A34A]">Valid certificate</div>
                                <div className="mt-6 text-left space-y-3">
                                    <div><div className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground">Issued to</div><div className="font-bold text-lg">{data.student_name}</div></div>
                                    <div><div className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground">Course</div><div className="font-bold">{data.course_title}</div></div>
                                    <div><div className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground">Certificate ID</div><div className="font-mono text-sm">{data.cert_number}</div></div>
                                    <div><div className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground">Issued on</div><div className="text-sm">{new Date(data.issued_at).toLocaleDateString()}</div></div>
                                </div>
                                <Button
                                    variant="outline" size="sm" className="mt-6"
                                    onClick={() => {
                                        navigator.clipboard.writeText(`${CERT_VERIFY_BASE_URL}/${data.cert_number}`);
                                        toast.success("Verification link copied");
                                    }}
                                    data-testid="copy-verify-link"
                                >
                                    <Copy className="h-4 w-4 mr-1.5" /> Copy verification link
                                </Button>
                            </div>
                        ) : (
                            <div className="mt-8">
                                <XCircle className="h-12 w-12 text-[#E11D48] mx-auto" />
                                <div className="font-display text-2xl mt-3 text-[#E11D48]">Not valid</div>
                                <div className="text-sm text-muted-foreground mt-2">This certificate could not be verified. It may have been revoked or never issued.</div>
                            </div>
                        )
                    }
                </CardContent>
            </Card>
        </div>
    );
}
